import React from "react";
import blogImage1 from "../imgs/blogImg5.jpg";
import blogImage2 from "../imgs/blogImg3.jpg";
import blogImage3 from "../imgs/blogImg1.jpeg";
import blogImage4 from "../imgs/blogImg2.jpg";
import ApiSecuriy from "../imgs/api-security.jpg";
import Mvc from "../imgs/mvc.jpg";

const Posts = () => {
  return (
    <div className="posts">
      <h1>Blog Posts</h1>

      {/* Blog Post | 1 */}
      <div className="post-item">
        <img src={blogImage1} alt="blog:React 101" className="post-img" />
        <div className="post-content">
          <h2 className="post-title">React 101</h2>
          <p className="post-pargrphs">
            By creating an account on playcode.io, you gain access to
            interactive lessons on CSS, HTML, JavaScript, and the React library.
            It's a great way to learn and sharpen your skills with instant
            feedback, notes, and step-by-step walkthroughs to help guide you
            along the way. The React topics covered are extensive—definitely
            recommend checking them out!
          </p>
          <h4 className="post-link-title">
            Link |{" "}
            <a className="post-links" href="https://playcode.io/learn/react">
              React Playground @ playcode.io/react
            </a>
          </h4>
        </div>
      </div>

      {/* Blog Post | 2 */}
      <div className="post-item">
        <img src={blogImage2} alt="User Experience" className="post-img" />
        <div className="post-content">
          <h2 className="post-title">User Experience</h2>
          <p className="post-pargrphs">
            A great resource for understanding best API practices and design
            approaches. My biggest takeaway so far is the idea of keeping the
            "User Experience" at the forefront of any design — understanding the
            user's goals, tasks, and progress throughout the process. There’s
            also a fantastic chapter on the importance of version control and
            managing different iterations of code—especially in large team
            projects. Funny how we’re literally doing that daily with GitHub!
          </p>
          <h4 className="post-link-title">
            Link |{" "}
            <a
              className="post-links"
              href="https://learning.oreilly.com/library/view/design-and-build/9781680508123/f_0020.xhtml#chp.http.git"
            >
              Read: Design & Build Great Web APIs @ oreilly.com
            </a>
          </h4>
        </div>
      </div>

      {/* Blog Post | 3 */}
      <div className="post-item">
        <img src={blogImage3} alt="Exercism" className="post-img" />
        <div className="post-content">
          <h2 className="post-title">Exercism</h2>
          <p className="post-pargrphs">
            Create a profile and start your learning journey in any of their 76
            different language tracks! I joined last month after a classmate
            recommended it, and I instantly loved it. I began with the
            TypeScript and JavaScript paths, and I highly recommend it to
            anyone—it’s fun and motivating!
          </p>
          <h4 className="post-link-title">
            Link |{" "}
            <a className="post-links" href="https://exercism.org/tracks">
              76 Languages to Master @ exercism.com/tracks
            </a>
          </h4>
        </div>
      </div>

      {/* Blog Post | 4 - Just for fun */}
      <div className="post-item">
        <img src={blogImage4} alt="Laws of UX" className="post-img" />
        <div className="post-content">
          <h2 className="post-title">Laws of UX</h2>
          <p className="post-pargrphs">
            This is such a cool resource that covers the best UX/UI laws,
            principles, and design practices. Ever since I was gifted the Laws
            of UX cards, I’ve found them fascinating—and they honestly helped
            spark my journey into web development! There’s something inspiring
            about understanding the psychology behind why users are drawn to
            certain designs, layouts, and patterns. Jon Yablonski did a
            phenomenal job with this project, and his ongoing work is just as
            great. This post was just for fun!
          </p>
          <h4 className="post-link-title">
            Link |{" "}
            <a className="post-links" href="https://lawsofux.com/">
              Check out Laws of UX @ lawsofux.com
            </a>
          </h4>
        </div>
      </div>

      {/* Blog Post | 5 - API Security */}
      <div className="api-post">
        <img src={ApiSecuriy} alt="API Security" className="api-post-img" />
        <div className="api-post-content">
          <h2 className="api-post-title">API Security</h2>
          <h3>| API Security 101</h3>
          <p className="api-post-pargrphs">
            What’s the deal with API security, and why is it so important? As
            data moves across different applications and services, if there
            isn’t a form of protection, that data can be intercepted, altered,
            or stolen without your knowledge. Securing APIs is absolutely
            critical—it should be a priority, not an afterthought.
          </p>
          <p>
            A good starting point is conducting a "Risk Assessment." Don’t
            assume people won’t misuse your data—assume someone will. Be
            proactive, secure your data, and protect your users’ information.
            What might seem like unimportant or non-sensitive data can still be
            valuable to attackers.
          </p>

          <h3>| The CIA Triad</h3>
          <p>
            The CIA Triad was new to me at first, but it’s a widely used model
            for developing and enforcing security policies.
          </p>
          <ul>
            <li>
              <strong>C: Confidentiality</strong> – Ensures only authorized
              individuals can access sensitive information through mechanisms
              like usernames, passwords, access control lists, and encryption.
            </li>
            <li>
              <strong>I: Integrity</strong> – Maintains data accuracy and
              consistency using encryption, backups, and redundancy systems.
            </li>
            <li>
              <strong>A: Availability</strong> – Guarantees that data and
              systems are accessible when needed through reliable hardware and
              maintenance procedures.
            </li>
          </ul>

          <p>
            <a
              className="post-links"
              href="https://geek-university.com/confidentiality-integrity-and-availability-cia-triad/"
            >
              The CIA Triad
            </a>
          </p>

          <h3>| Other Takeaways</h3>
          <p>
            <strong>Unhandled HTTP Methods:</strong> Many APIs use HTTP methods
            to request, save, or delete data. Some servers may allow unsafe
            methods that can bypass authentication if not properly blocked.
            Check out this great article by{" "}
            <strong>Israel Aráoz Sanchez</strong>, where he demonstrates how
            easily an insecure API can be exploited to change data.
          </p>
          <a
            className="post-links"
            href="https://iaraoz.medium.com/web-security-academy-api-security-testing-walkthrough-11019ed93eae"
          >
            Web Security Academy — API Security Testing Walkthrough
          </a>

          <h3>| OWASP and API Security</h3>
          <p>
            OWASP (Open Worldwide Application Security Project) is a globally
            recognized organization that improves software security. Their API
            Security Top 10 lists the most common vulnerabilities and how to
            address them effectively.
          </p>
          <p>
            Learn more at:{" "}
            <a
              href="https://owasp.org/www-project-api-security/"
              className="post-links"
            >
              OWASP | API Security
            </a>{" "}
            or check out their{" "}
            <a
              href="https://cheatsheetseries.owasp.org/cheatsheets/Authentication_Cheat_Sheet.html"
              className="post-links"
            >
              Authentication Cheat Sheet
            </a>
            .
          </p>

          <h3>| Final Thoughts</h3>
          <p>
            Securing APIs should never be an afterthought—it’s a necessity. APIs
            power modern applications, and if left vulnerable, they can expose
            sensitive information and damage user trust. Understanding risk
            assessment and applying the CIA Triad helps protect data and uphold
            integrity across systems.
          </p>

          <h4 className="post-link-title">Other Links & Resources</h4>
          <ul>
            <li>
              <a
                className="post-links"
                href="https://curity.io/resources/learn/api-security-best-practices/"
              >
                API Security Best Practices
              </a>
            </li>
            <li>
              <a
                className="post-links"
                href="https://security.stackexchange.com/questions/241575/what-are-the-risks-of-having-an-unsecured-api-if-theres-nothing-sensitive-in-t"
              >
                Risks of an Unsecured API
              </a>
              <p>
                This Q&A thread highlights how even non-sensitive APIs can
                expose critical data. One example discusses how Strava’s
                heatmaps unintentionally revealed U.S. military bases—a reminder
                that oversight can have serious consequences.
              </p>
            </li>
            <li>
              <a
                className="post-links"
                href="https://books.google.com/books?id=7TczEAAAQBAJ"
              >
                API Security in Action — Neil Madden
              </a>
              <p>
                A great read covering API security principles, CIA Triad
                practices, and real-world implementation tips.
              </p>
            </li>
            <li>
              <a
                className="post-links"
                href="https://www.fortinet.com/resources/cyberglossary/ddos-attack"
              >
                REST API Security Essentials
              </a>
              <p>
                Explores the use of HTTPS, OAuth authentication, input
                validation, and rate limiting to prevent attacks such as DDoS or
                injection exploits.
              </p>
            </li>
          </ul>
        </div>
      </div>

      {/* Blog Post | 6 - MVC Model */}
      <div className="api-post">
        <img src={Mvc} alt="MVC Design Pattern" className="api-post-img" />
        <div className="api-post-content">
          <h2 className="api-post-title">MVC Design Pattern 101</h2>
          <h3>| What Is It?</h3>
          <p className="api-post-pargrphs">
            The Model-View-Controller (MVC) pattern is a widely used design
            structure that helps developers manage complex web applications by
            separating them into three main components: Model, View, and
            Controller.
          </p>
          <p>
            Each component handles a distinct function, making it easier to
            test, maintain, and scale applications. The MVC approach keeps
            logic, design, and data organized and allows smoother debugging and
            updates.
          </p>
          <ul>
            <li>
              <strong>Model:</strong> Defines the data structure, schemas, and
              validation rules used throughout the application.
            </li>
            <li>
              <strong>View:</strong> Controls how data is presented to users,
              including layout, styling, and display updates.
            </li>
            <li>
              <strong>Controller:</strong> Acts as the “brain” of the
              application, handling logic and communication between the Model
              and View.
            </li>
          </ul>

          <p>
            <a
              className="post-links"
              href="https://www.youtube.com/watch?v=bQuBlR0T5cc"
            >
              MVC Pattern Explained | MVC Tutorial (PedroTech)
            </a>
          </p>

          <h3>| Final Thoughts</h3>
          <p>
            Structuring your code properly makes a huge difference when building
            applications. The MVC model helps developers create clean, scalable
            projects by separating concerns and keeping things organized. As
            your app grows, this approach simplifies debugging and long-term
            maintenance—you’ll thank yourself later!
          </p>

          <h4 className="post-link-title">Other Links & Resources</h4>
          <ul>
            <li>
              <a
                className="post-links"
                href="https://developer.mozilla.org/en-US/docs/Glossary/MVC"
              >
                MVC | MDN Web Docs
              </a>
            </li>
            <li>
              <a
                className="post-links"
                href="https://www.geeksforgeeks.org/mvc-framework-introduction/"
              >
                MVC Framework Introduction | GeeksforGeeks
              </a>
            </li>
            <li>
              <a
                className="post-links"
                href="https://www.ramotion.com/blog/mvc-architecture-in-web-application/"
              >
                MVC Architecture: Simplifying Web Application Development
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Posts;
